export default __webpack_public_path__ + "static/media/card-blog7.637fb50e.jpg";